import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _extends } from "@swc/helpers/_/_extends";
import { _ as _object_destructuring_empty } from "@swc/helpers/_/_object_destructuring_empty";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Card, CardBody, Row, Col, Form, Button, Modal } from "react-bootstrap";
import { Stack } from "@mui/material";
import Select from "react-select";
import { useDropzone } from "react-dropzone";
import { nanoid } from "nanoid";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import DataTableLayout from "layouts/DatatableLayout";
import DatatableLayoutPagination from "layouts/DatatableLayoutPagination";
import { ModalAllder } from "layouts/ModalAllder";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutline from "@mui/icons-material/DeleteOutline";
import ReceiptIcon from "@mui/icons-material/Receipt";
import LocalAtmIcon from "@mui/icons-material/LocalAtm";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { formatNumber, filterTextAndNum } from "utils/HelperFunction";
import { getAllImportInvoiceMt, clearGetAllImportInvoiceMt } from "../../redux/handlers/import_invoice/getAllImportInvoiceMt.handler";
import { uploadImportFileInvMt, clearUploadImportFileInvMt } from "../../redux/handlers/import_invoice/uploadImportFileInvMt.handler";
import { confirmImportInvMt, clearConfirmImportInvMt } from "../../redux/handlers/import_invoice/confirmImportInvMt.handler";
import { getAllImportInvoiceTt, clearGetAllImportInvoiceTt } from "../../redux/handlers/import_invoice/getAllImportInvoiceTt.handler";
import { uploadImportFileInvTt, clearUploadImportFileInvTt } from "../../redux/handlers/import_invoice/uploadImportFileInvTt.handler";
import { confirmImportInvTt, clearConfirmImportInvTt } from "../../redux/handlers/import_invoice/confirmImportInvTt.handler";
export function ImportInvoiceMt() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState(""), 2), filterText = _useState[0], setFilterText = _useState[1];
    var _useState1 = _sliced_to_array(useState(""), 2), modelText = _useState1[0], setmodelText = _useState1[1];
    var _useState2 = _sliced_to_array(useState([]), 2), filteredItems = _useState2[0], setFilteredItems = _useState2[1];
    var _useState3 = _sliced_to_array(useState([]), 2), rowData = _useState3[0], setRowData = _useState3[1];
    var _useState4 = _sliced_to_array(useState(false), 2), modalsuccess = _useState4[0], setModalsuccess = _useState4[1];
    var _useState5 = _sliced_to_array(useState(false), 2), textsuccess = _useState5[0], setTextsuccess = _useState5[1];
    var _useState6 = _sliced_to_array(useState(false), 2), modalShow = _useState6[0], setModalShow = _useState6[1];
    var _useState7 = _sliced_to_array(useState([]), 2), invoiceData = _useState7[0], setInvoiceData = _useState7[1];
    var _useState8 = _sliced_to_array(useState(null), 2), previewId = _useState8[0], setPreviewId = _useState8[1];
    var _useState9 = _sliced_to_array(useState(1), 2), pageId = _useState9[0], setPageId = _useState9[1];
    var _useState10 = _sliced_to_array(useState(10), 2), pageSize = _useState10[0], setPageSize = _useState10[1];
    var _useState11 = _sliced_to_array(useState([]), 2), sortModel = _useState11[0], setSortModel = _useState11[1];
    var _useState12 = _sliced_to_array(useState(false), 2), loading = _useState12[0], setLoading = _useState12[1];
    var _useState13 = _sliced_to_array(useState(0), 2), totalPage = _useState13[0], setTotalPage = _useState13[1];
    var _useState14 = _sliced_to_array(useState(0), 2), totalAmount = _useState14[0], setTotalAmount = _useState14[1];
    var _useState15 = _sliced_to_array(useState(false), 2), detailShow = _useState15[0], setDetailShow = _useState15[1];
    var _useState16 = _sliced_to_array(useState(""), 2), schCusName = _useState16[0], setSchCusName = _useState16[1];
    var _useState17 = _sliced_to_array(useState(""), 2), schCusCode = _useState17[0], setSchCusCode = _useState17[1];
    var _useState18 = _sliced_to_array(useState(""), 2), schInvCode = _useState18[0], setSchInvCode = _useState18[1];
    var _useState19 = _sliced_to_array(useState(moment().subtract({
        days: 1
    }).format("YYYY-MM-DD")), 2), schImpStart = _useState19[0], setSchImpStart = _useState19[1];
    var _useState20 = _sliced_to_array(useState(moment().format("YYYY-MM-DD")), 2), schImpEnd = _useState20[0], setSchImpEnd = _useState20[1];
    var _useState21 = _sliced_to_array(useState(""), 2), schDocStart = _useState21[0], setSchDocStart = _useState21[1];
    var _useState22 = _sliced_to_array(useState(""), 2), schDocEnd = _useState22[0], setSchDocEnd = _useState22[1];
    var _useState23 = _sliced_to_array(useState(""), 2), schUpStart = _useState23[0], setSchUpStart = _useState23[1];
    var _useState24 = _sliced_to_array(useState(""), 2), schUpEnd = _useState24[0], setSchUpEnd = _useState24[1];
    var _useState25 = _sliced_to_array(useState({
        amountInv: 0,
        amountTotal: 0
    }), 2), sumTotalInv = _useState25[0], setSumTotalInv = _useState25[1];
    var getAllImportInvoiceMtReducer = useAppSelector(function(state) {
        return state.getAllImportInvoiceMtReducer;
    });
    var columns = [
        {
            name: "รหัสลูกค้า",
            selector: function(row) {
                return row.import_inv_customer_code || "-";
            },
            center: "true",
            minWidth: "200px"
        },
        {
            name: "ชื่อลูกค้า",
            selector: function(row) {
                return row.import_inv_customer_name || "-";
            },
            minWidth: "200px"
        },
        {
            name: "วันที่เอกสาร",
            selector: function(row) {
                return row.import_inv_date;
            },
            right: "true",
            minWidth: "150px",
            cell: function(row) {
                return /*#__PURE__*/ _jsx(_Fragment, {
                    children: row.import_inv_date && row.import_inv_date != "" && row.import_inv_date != null ? moment(row.import_inv_date).format("DD/MM/YYYY") : "-"
                });
            }
        },
        {
            name: "เลขที่เอกสาร",
            selector: function(row) {
                return row.import_inv_doc_code || "-";
            },
            center: "true",
            minWidth: "200px"
        },
        {
            name: "ยอดรวมสุธิ (บาท)",
            selector: function(row) {
                return row.import_inv_total_bath;
            },
            right: "true",
            minWidth: "200px",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx("div", {
                    className: "w-100 text-right",
                    children: formatNumber(row.import_inv_total_bath) || "0.00"
                });
            }
        },
        {
            name: "สกุลเงินในเอกสาร",
            selector: function(row) {
                return row.import_inv_currency || "-";
            },
            center: "true",
            minWidth: "150px"
        },
        {
            name: "ยอดรวมสุทธิ(ตามเอกสาร)",
            selector: function(row) {
                return row.import_inv_total_doc;
            },
            right: "true",
            minWidth: "200px",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx("div", {
                    className: "w-100 text-right",
                    children: formatNumber(row.import_inv_total_doc) || "0.00"
                });
            }
        },
        {
            name: "สถานะ",
            selector: function(row) {
                return row.import_inv_status;
            },
            center: "true",
            width: "180px",
            sortable: true,
            sortField: "import_inv_status",
            cell: function(row, index, column, id) {
                return row.import_inv_status == 1 ? /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "rgba(114, 225, 40, 0.87)",
                        backgroundColor: "rgba(238, 251, 229, 1)",
                        borderRadius: "20px",
                        width: "130px"
                    },
                    children: row.import_inv_status_text || "ชำระแล้ว"
                }) : row.import_inv_status == 2 ? /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "rgba(253, 180, 40, 1)",
                        backgroundColor: "rgba(255, 246, 229, 1)",
                        borderRadius: "20px",
                        width: "130px"
                    },
                    children: row.import_inv_status_text || "รอชำระ"
                }) : /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "rgba(116, 116, 116, 1)",
                        backgroundColor: "rgba(244, 244, 244, 1)",
                        borderRadius: "20px",
                        width: "130px"
                    },
                    children: row.import_inv_status_text || "ไม่ระบุ"
                });
            }
        },
        {
            name: "วันที่อัพโหลด",
            selector: function(row) {
                return row.import_inv_update_date;
            },
            center: "true",
            minWidth: "150px",
            cell: function(row) {
                return /*#__PURE__*/ _jsx(_Fragment, {
                    children: row.import_inv_update_date && row.import_inv_update_date != "" && row.import_inv_update_date != null ? moment(row.import_inv_update_date).format("DD/MM/YYYY") : "-"
                });
            }
        }
    ];
    var fetchImportInvoices = function(param) {
        var customName = param.customName, customCode = param.customCode, invoiceCode = param.invoiceCode, dateImportStart = param.dateImportStart, dateImportEnd = param.dateImportEnd, dateDocStart = param.dateDocStart, dateDocEnd = param.dateDocEnd, dateUpStart = param.dateUpStart, dateUpEnd = param.dateUpEnd, pId = param.pId, pSize = param.pSize, sortField = param.sortField, sortValue = param.sortValue, resetList = param.resetList;
        // const qPageId = `pageId=${pId || "1"}`;
        // const qPageSize = `pageSize=${pSize || "10"}`;
        // const fullQuery = [
        //   qPageId,
        //   qPageSize,
        // ]
        //   .filter(Boolean)
        //   .join("&");
        var dataQuery = _object_spread({
            customername: filterTextAndNum(customName) || null,
            customercode: filterTextAndNum(customCode) || null,
            documentno: filterTextAndNum(invoiceCode) || null,
            importsdate: filterTextAndNum(dateImportStart) ? moment(dateImportStart).format("YYYY-MM-DD") : null,
            importedate: filterTextAndNum(dateImportEnd) ? moment(dateImportEnd).format("YYYY-MM-DD") : null,
            documentsdate: filterTextAndNum(dateDocStart) ? moment(dateDocStart).format("YYYY-MM-DD") : null,
            documentedate: filterTextAndNum(dateDocEnd) ? moment(dateDocEnd).format("YYYY-MM-DD") : null,
            updatesdate: filterTextAndNum(dateUpStart) ? moment(dateUpStart).format("YYYY-MM-DD") : null,
            updateedate: filterTextAndNum(dateUpEnd) ? moment(dateUpEnd).format("YYYY-MM-DD") : null,
            pageId: pId || 1,
            pageSize: pSize || 10
        }, sortField && sortValue && {
            sortField: sortField,
            sortValue: sortValue
        });
        if (resetList) {
            setRowData([]);
        }
        dispatch(getAllImportInvoiceMt(dataQuery, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    var reLoadData = function() {
        var _ref = _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            setSchImpStart(moment().format("YYYY-MM-DD 00:00:00"))
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            setSchImpEnd(moment().format("YYYY-MM-DD 00:00:00"))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            setPageId(1)
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function reLoadData() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleChangePage = function(newPage) {
        setPageId(newPage);
    };
    var handleChangeRowsPerPage = function(newPageSize) {
        setPageSize(newPageSize);
    };
    var handleSort = function(column, sortDirection) {
        var field = column === null || column === void 0 ? void 0 : column.sortField;
        var value = sortDirection; // 'asc' หรือ 'desc'
        console.log("Sort:", {
            sortField: field,
            sortValue: value
        });
        setSortModel({
            sortField: field,
            sortValue: value
        });
    };
    useEffect(function() {
        var init = function init() {
            return _init.apply(this, arguments);
        };
        function _init() {
            _init = _async_to_generator(function() {
                return _ts_generator(this, function(_state) {
                    fetchImportInvoices({
                        dateImportStart: schImpStart,
                        dateImportEnd: schImpEnd,
                        pId: pageId,
                        pSize: pageSize
                    });
                    return [
                        2
                    ];
                });
            });
            return _init.apply(this, arguments);
        }
        init();
    }, []);
    useEffect(function() {
        fetchImportInvoices(_object_spread_props(_object_spread({
            customName: schCusName,
            customCode: schCusCode,
            invoiceCode: schInvCode,
            dateImportStart: schImpStart,
            dateImportEnd: schImpEnd,
            dateDocStart: schDocStart,
            dateDocEnd: schDocEnd,
            dateUpStart: schUpStart,
            dateUpEnd: schUpEnd,
            pId: pageId,
            pSize: pageSize
        }, sortModel && {
            sortField: sortModel.sortField,
            sortValue: sortModel.sortValue
        }), {
            resetList: true
        }));
    }, [
        schCusName,
        schCusCode,
        schInvCode,
        schImpStart,
        schImpEnd,
        schDocStart,
        schDocEnd,
        schUpStart,
        schUpEnd,
        pageId,
        pageSize,
        sortModel
    ]);
    useEffect(function() {
        setIsLoading(getAllImportInvoiceMtReducer.isFetching);
        if (getAllImportInvoiceMtReducer.data && !getAllImportInvoiceMtReducer.isError) {
            var _datas_data, _datas_data1;
            var datas = getAllImportInvoiceMtReducer.data.data;
            if (!datas) {
                return navigate("/404", {
                    replace: true
                });
            }
            // const dataWithReplacements = Object.entries(datas).reduce(
            //     (acc, [key, value]) => {
            //         acc[key] = value === null ? "" : value;
            //             return acc;
            //         },
            //     {}
            // );
            if (datas && ((_datas_data = datas.data) === null || _datas_data === void 0 ? void 0 : _datas_data.length) && ((_datas_data1 = datas.data) === null || _datas_data1 === void 0 ? void 0 : _datas_data1.length) > 0) {
                var _datas_data2;
                setRowData((_datas_data2 = datas.data) === null || _datas_data2 === void 0 ? void 0 : _datas_data2.map(function(item) {
                    return _object_spread_props(_object_spread({}, item), {
                        import_inv_total_bath: item.import_inv_total_bath.d.length && item.import_inv_total_bath.d.length > 0 ? filterTextAndNum(item.import_inv_total_bath.d[0], 2) : 0,
                        import_inv_total_doc: item.import_inv_total_doc.d.length && item.import_inv_total_doc.d.length > 0 ? filterTextAndNum(item.import_inv_total_doc.d[0], 2) : 0
                    });
                }));
                var pagination = datas.pagination;
                setTotalPage((pagination === null || pagination === void 0 ? void 0 : pagination.totalPage) || 0);
                setTotalAmount((pagination === null || pagination === void 0 ? void 0 : pagination.total) || 0);
            }
        }
    }, [
        getAllImportInvoiceMtReducer
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0 mb-1",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "จัดการ"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "นำเข้าไฟล์ invoice MT"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 mb-2",
                        children: "นำเข้าไฟล์ invoice MT"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                children: /*#__PURE__*/ _jsxs(Card, {
                    children: [
                        /*#__PURE__*/ _jsx(CardBody, {
                            children: /*#__PURE__*/ _jsxs(Row, {
                                children: [
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 9,
                                        lg: true,
                                        children: /*#__PURE__*/ _jsxs(Row, {
                                            children: [
                                                /*#__PURE__*/ _jsx(Col, {
                                                    xs: 12,
                                                    md: 4,
                                                    lg: 3,
                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                        className: "mb-3 form-st-3 mt-0",
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                className: "mb-1",
                                                                children: "วันที่นำเข้าเริ่มต้น"
                                                            }),
                                                            /*#__PURE__*/ _jsx(DatePicker, {
                                                                inputFormat: "DD/MM/YYYY",
                                                                selected: schImpStart ? moment(schImpStart).toDate() : "",
                                                                onChange: function(date) {
                                                                    if (moment(date).isValid()) {
                                                                        setSchImpStart(moment(date).format("YYYY-MM-DD 00:00:00"));
                                                                    } else {
                                                                        setSchImpStart("");
                                                                    }
                                                                },
                                                                placeholder: "DD/MM/YYYY",
                                                                className: "w-100 datepicker2",
                                                                value: schImpStart ? moment(schImpStart).format("DD/MM/YYYY") : ""
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx(Col, {
                                                    xs: 12,
                                                    md: 4,
                                                    lg: 3,
                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                        className: "mb-3 form-st-3 mt-0",
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                className: "mb-1",
                                                                children: "วันที่นำเข้าสิ้นสุด"
                                                            }),
                                                            /*#__PURE__*/ _jsx(DatePicker, {
                                                                inputFormat: "DD/MM/YYYY",
                                                                selected: schImpEnd ? moment(schImpEnd).toDate() : "",
                                                                onChange: function(date) {
                                                                    if (moment(date).isValid()) {
                                                                        setSchImpEnd(moment(date).format("YYYY-MM-DD 00:00:00"));
                                                                    } else {
                                                                        setSchImpEnd("");
                                                                    }
                                                                },
                                                                placeholder: "DD/MM/YYYY",
                                                                className: "w-100 datepicker2",
                                                                value: schImpEnd ? moment(schImpEnd).format("DD/MM/YYYY") : ""
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx(Col, {
                                                    xs: 12,
                                                    md: 4,
                                                    lg: 3,
                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                        className: "mb-3 form-st-3 mt-0",
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                className: "mb-1",
                                                                children: "วันที่เอกสารเริ่มต้น"
                                                            }),
                                                            /*#__PURE__*/ _jsx(DatePicker, {
                                                                inputFormat: "DD/MM/YYYY",
                                                                selected: schDocStart ? moment(schDocStart).toDate() : "",
                                                                onChange: function(date) {
                                                                    if (moment(date).isValid()) {
                                                                        setSchDocStart(moment(date).format("YYYY-MM-DD 00:00:00"));
                                                                    } else {
                                                                        setSchDocStart("");
                                                                    }
                                                                },
                                                                placeholder: "DD/MM/YYYY",
                                                                className: "w-100 datepicker2",
                                                                value: schDocStart ? moment(schDocStart).format("DD/MM/YYYY") : ""
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx(Col, {
                                                    xs: 12,
                                                    md: 4,
                                                    lg: 3,
                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                        className: "mb-3 form-st-3 mt-0",
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                className: "mb-1",
                                                                children: "วันที่เอกสารสิ้นสุด"
                                                            }),
                                                            /*#__PURE__*/ _jsx(DatePicker, {
                                                                inputFormat: "DD/MM/YYYY",
                                                                selected: schDocEnd ? moment(schDocEnd).toDate() : "",
                                                                onChange: function(date) {
                                                                    if (moment(date).isValid()) {
                                                                        setSchDocEnd(moment(date).format("YYYY-MM-DD 00:00:00"));
                                                                    } else {
                                                                        setSchDocEnd("");
                                                                    }
                                                                },
                                                                placeholder: "DD/MM/YYYY",
                                                                className: "w-100 datepicker2",
                                                                value: schDocEnd ? moment(schDocEnd).format("DD/MM/YYYY") : ""
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx(Col, {
                                                    xs: 12,
                                                    md: 4,
                                                    lg: 3,
                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                        className: "mb-3 form-st-3 mt-0",
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                className: "mb-1",
                                                                children: "วันที่อัพเดทเริ่มต้น"
                                                            }),
                                                            /*#__PURE__*/ _jsx(DatePicker, {
                                                                inputFormat: "DD/MM/YYYY",
                                                                selected: schUpStart ? moment(schUpStart).toDate() : "",
                                                                onChange: function(date) {
                                                                    if (moment(date).isValid()) {
                                                                        setSchUpStart(moment(date).format("YYYY-MM-DD 00:00:00"));
                                                                    } else {
                                                                        setSchUpStart("");
                                                                    }
                                                                },
                                                                placeholder: "DD/MM/YYYY",
                                                                className: "w-100 datepicker2",
                                                                value: schUpStart ? moment(schUpStart).format("DD/MM/YYYY") : ""
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx(Col, {
                                                    xs: 12,
                                                    md: 4,
                                                    lg: 3,
                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                        className: "mb-3 form-st-3 mt-0",
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                className: "mb-1",
                                                                children: "วันที่อัพเดทสิ้นสุด"
                                                            }),
                                                            /*#__PURE__*/ _jsx(DatePicker, {
                                                                inputFormat: "DD/MM/YYYY",
                                                                selected: schUpEnd ? moment(schUpEnd).toDate() : "",
                                                                onChange: function(date) {
                                                                    if (moment(date).isValid()) {
                                                                        setSchUpEnd(moment(date).format("YYYY-MM-DD 00:00:00"));
                                                                    } else {
                                                                        setSchUpEnd("");
                                                                    }
                                                                },
                                                                placeholder: "DD/MM/YYYY",
                                                                className: "w-100 datepicker2",
                                                                value: schUpEnd ? moment(schUpEnd).format("DD/MM/YYYY") : ""
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx(Col, {
                                                    xs: 12,
                                                    md: 4,
                                                    lg: 3,
                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                        className: "mb-3 form-st-3 mt-0",
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                className: "mb-1",
                                                                children: "เลขที่เอกสาร"
                                                            }),
                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                type: "text",
                                                                placeholder: "ค้นหา เลขที่เอกสาร",
                                                                onChange: function(e) {
                                                                    return setSchInvCode(e.target.value);
                                                                },
                                                                value: schInvCode
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx(Col, {
                                                    xs: 12,
                                                    md: 4,
                                                    lg: 3,
                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                        className: "mb-3 form-st-3 mt-0",
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                className: "mb-1",
                                                                children: "รหัสลูกค้า"
                                                            }),
                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                type: "text",
                                                                placeholder: "ค้นหา รหัสลูกค้า",
                                                                onChange: function(e) {
                                                                    return setSchCusCode(e.target.value);
                                                                },
                                                                value: schCusCode
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx(Col, {
                                                    xs: 12,
                                                    md: 4,
                                                    lg: 3,
                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                        className: "mb-3 form-st-3 mt-0",
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                className: "mb-1",
                                                                children: "ชื่อลูกค้า"
                                                            }),
                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                type: "text",
                                                                placeholder: "ค้นหา ชื่อลูกค้า",
                                                                onChange: function(e) {
                                                                    return setSchCusName(e.target.value);
                                                                },
                                                                value: schCusName
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        lg: "auto",
                                        children: /*#__PURE__*/ _jsx(Stack, {
                                            direction: "horizontal",
                                            children: /*#__PURE__*/ _jsx(Button, {
                                                className: "btn btn-dg ml-2 w-[250px] fs-14",
                                                onClick: function() {
                                                    return setModalShow(true);
                                                },
                                                children: "นำเข้าข้อมูล"
                                            })
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx(DatatableLayoutPagination, {
                            item: rowData,
                            columns: columns,
                            isSelectRows: false,
                            currentPage: pageId,
                            currentPageSize: pageSize,
                            onChangePage: handleChangePage,
                            onChangePageSize: handleChangeRowsPerPage,
                            totalPage: totalPage,
                            totalAmount: totalAmount,
                            sortModel: sortModel,
                            onChangeSort: setSortModel,
                            handleSort: handleSort,
                            loading: loading
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(ImportFileModal, {
                show: modalShow,
                onHide: function() {
                    return setModalShow(false);
                },
                setInvoiceData: setInvoiceData,
                invoiceData: invoiceData,
                previewId: previewId,
                setPreviewId: setPreviewId,
                sumTotalInv: sumTotalInv,
                setSumTotalInv: setSumTotalInv,
                modalTitle: "นำเข้าไฟล์ invoice MT",
                modalType: "MT",
                previewShow: function() {
                    setModalShow(false);
                    setDetailShow(true);
                }
            }),
            /*#__PURE__*/ _jsx(SaveItemModal, {
                show: detailShow,
                onHide: function() {
                    return setDetailShow(false);
                },
                setInvoiceData: setInvoiceData,
                invoiceData: invoiceData,
                previewId: previewId,
                setPreviewId: setPreviewId,
                sumTotalInv: sumTotalInv,
                setSumTotalInv: setSumTotalInv,
                modalTitle: "ข้อมูล invoice MT",
                modalType: "MT",
                setTextsuccess: setTextsuccess,
                successShow: function() {
                    reLoadData();
                    setDetailShow(false);
                    setModalsuccess(true);
                }
            }),
            /*#__PURE__*/ _jsx(SuccessModal, {
                show: modalsuccess,
                onHide: function() {
                    return setModalsuccess(false);
                },
                textsuccess: textsuccess,
                navigate: navigate
            })
        ]
    });
}
export function ImportInvoiceTt() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState(""), 2), filterText = _useState[0], setFilterText = _useState[1];
    var _useState1 = _sliced_to_array(useState(""), 2), modelText = _useState1[0], setmodelText = _useState1[1];
    var _useState2 = _sliced_to_array(useState([]), 2), filteredItems = _useState2[0], setFilteredItems = _useState2[1];
    var _useState3 = _sliced_to_array(useState([]), 2), rowData = _useState3[0], setRowData = _useState3[1];
    var _useState4 = _sliced_to_array(useState(false), 2), modalsuccess = _useState4[0], setModalsuccess = _useState4[1];
    var _useState5 = _sliced_to_array(useState(false), 2), textsuccess = _useState5[0], setTextsuccess = _useState5[1];
    var _useState6 = _sliced_to_array(useState(false), 2), modalShow = _useState6[0], setModalShow = _useState6[1];
    var _useState7 = _sliced_to_array(useState([]), 2), invoiceData = _useState7[0], setInvoiceData = _useState7[1];
    var _useState8 = _sliced_to_array(useState(null), 2), previewId = _useState8[0], setPreviewId = _useState8[1];
    var _useState9 = _sliced_to_array(useState(1), 2), pageId = _useState9[0], setPageId = _useState9[1];
    var _useState10 = _sliced_to_array(useState(10), 2), pageSize = _useState10[0], setPageSize = _useState10[1];
    var _useState11 = _sliced_to_array(useState([]), 2), sortModel = _useState11[0], setSortModel = _useState11[1];
    var _useState12 = _sliced_to_array(useState(false), 2), loading = _useState12[0], setLoading = _useState12[1];
    var _useState13 = _sliced_to_array(useState(0), 2), totalPage = _useState13[0], setTotalPage = _useState13[1];
    var _useState14 = _sliced_to_array(useState(0), 2), totalAmount = _useState14[0], setTotalAmount = _useState14[1];
    var _useState15 = _sliced_to_array(useState(false), 2), detailShow = _useState15[0], setDetailShow = _useState15[1];
    var _useState16 = _sliced_to_array(useState(""), 2), schCusName = _useState16[0], setSchCusName = _useState16[1];
    var _useState17 = _sliced_to_array(useState(""), 2), schCusCode = _useState17[0], setSchCusCode = _useState17[1];
    var _useState18 = _sliced_to_array(useState(""), 2), schInvCode = _useState18[0], setSchInvCode = _useState18[1];
    var _useState19 = _sliced_to_array(useState(moment().subtract({
        days: 1
    }).format("YYYY-MM-DD")), 2), schImpStart = _useState19[0], setSchImpStart = _useState19[1];
    var _useState20 = _sliced_to_array(useState(moment().format("YYYY-MM-DD")), 2), schImpEnd = _useState20[0], setSchImpEnd = _useState20[1];
    var _useState21 = _sliced_to_array(useState(""), 2), schDocStart = _useState21[0], setSchDocStart = _useState21[1];
    var _useState22 = _sliced_to_array(useState(""), 2), schDocEnd = _useState22[0], setSchDocEnd = _useState22[1];
    var _useState23 = _sliced_to_array(useState(""), 2), schUpStart = _useState23[0], setSchUpStart = _useState23[1];
    var _useState24 = _sliced_to_array(useState(""), 2), schUpEnd = _useState24[0], setSchUpEnd = _useState24[1];
    var _useState25 = _sliced_to_array(useState({
        amountInv: 0,
        amountTotal: 0
    }), 2), sumTotalInv = _useState25[0], setSumTotalInv = _useState25[1];
    var getAllImportInvoiceTtReducer = useAppSelector(function(state) {
        return state.getAllImportInvoiceTtReducer;
    });
    var columns = [
        {
            name: "รหัสลูกค้า",
            selector: function(row) {
                return row.import_inv_customer_code || "-";
            },
            center: "true",
            minWidth: "200px"
        },
        {
            name: "ชื่อลูกค้า",
            selector: function(row) {
                return row.import_inv_customer_name || "-";
            },
            minWidth: "200px"
        },
        {
            name: "วันที่เอกสาร",
            selector: function(row) {
                return row.import_inv_date;
            },
            right: "true",
            minWidth: "150px",
            cell: function(row) {
                return /*#__PURE__*/ _jsx(_Fragment, {
                    children: row.import_inv_date && row.import_inv_date != "" && row.import_inv_date != null ? moment(row.import_inv_date).format("DD/MM/YYYY") : "-"
                });
            }
        },
        {
            name: "เลขที่เอกสาร",
            selector: function(row) {
                return row.import_inv_doc_code || "-";
            },
            center: "true",
            minWidth: "200px"
        },
        {
            name: "ยอดรวมสุธิ (บาท)",
            selector: function(row) {
                return row.import_inv_total_bath;
            },
            right: "true",
            minWidth: "200px",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx("div", {
                    className: "w-100 text-right",
                    children: formatNumber(row.import_inv_total_bath) || "0.00"
                });
            }
        },
        {
            name: "สกุลเงินในเอกสาร",
            selector: function(row) {
                return row.import_inv_currency || "-";
            },
            center: "true",
            minWidth: "150px"
        },
        {
            name: "ยอดรวมสุทธิ(ตามเอกสาร)",
            selector: function(row) {
                return row.import_inv_total_doc;
            },
            right: "true",
            minWidth: "200px",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx("div", {
                    className: "w-100 text-right",
                    children: formatNumber(row.import_inv_total_doc) || "0.00"
                });
            }
        },
        {
            name: "สถานะ",
            selector: function(row) {
                return row.import_inv_status;
            },
            center: "true",
            width: "180px",
            sortable: true,
            sortField: "import_inv_status",
            cell: function(row, index, column, id) {
                return row.import_inv_status == 1 ? /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "rgba(114, 225, 40, 0.87)",
                        backgroundColor: "rgba(238, 251, 229, 1)",
                        borderRadius: "20px",
                        width: "130px"
                    },
                    children: row.import_inv_status_text || "ชำระแล้ว"
                }) : row.import_inv_status == 2 ? /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "rgba(253, 180, 40, 1)",
                        backgroundColor: "rgba(255, 246, 229, 1)",
                        borderRadius: "20px",
                        width: "130px"
                    },
                    children: row.import_inv_status_text || "รอชำระ"
                }) : /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "rgba(116, 116, 116, 1)",
                        backgroundColor: "rgba(244, 244, 244, 1)",
                        borderRadius: "20px",
                        width: "130px"
                    },
                    children: row.import_inv_status_text || "ไม่ระบุ"
                });
            }
        },
        {
            name: "วันที่อัพโหลด",
            selector: function(row) {
                return row.import_inv_update_date;
            },
            center: "true",
            minWidth: "150px",
            cell: function(row) {
                return /*#__PURE__*/ _jsx(_Fragment, {
                    children: row.import_inv_update_date && row.import_inv_update_date != "" && row.import_inv_update_date != null ? moment(row.import_inv_update_date).format("DD/MM/YYYY") : "-"
                });
            }
        }
    ];
    var fetchImportInvoices = function(param) {
        var customName = param.customName, customCode = param.customCode, invoiceCode = param.invoiceCode, dateImportStart = param.dateImportStart, dateImportEnd = param.dateImportEnd, dateDocStart = param.dateDocStart, dateDocEnd = param.dateDocEnd, dateUpStart = param.dateUpStart, dateUpEnd = param.dateUpEnd, pId = param.pId, pSize = param.pSize, sortField = param.sortField, sortValue = param.sortValue, resetList = param.resetList;
        // const qPageId = `pageId=${pId || "1"}`;
        // const qPageSize = `pageSize=${pSize || "10"}`;
        // const fullQuery = [
        //   qPageId,
        //   qPageSize,
        // ]
        //   .filter(Boolean)
        //   .join("&");
        var dataQuery = _object_spread({
            customername: filterTextAndNum(customName) || null,
            customercode: filterTextAndNum(customCode) || null,
            documentno: filterTextAndNum(invoiceCode) || null,
            importsdate: filterTextAndNum(dateImportStart) ? moment(dateImportStart).format("YYYY-MM-DD") : null,
            importedate: filterTextAndNum(dateImportEnd) ? moment(dateImportEnd).format("YYYY-MM-DD") : null,
            documentsdate: filterTextAndNum(dateDocStart) ? moment(dateDocStart).format("YYYY-MM-DD") : null,
            documentedate: filterTextAndNum(dateDocEnd) ? moment(dateDocEnd).format("YYYY-MM-DD") : null,
            updatesdate: filterTextAndNum(dateUpStart) ? moment(dateUpStart).format("YYYY-MM-DD") : null,
            updateedate: filterTextAndNum(dateUpEnd) ? moment(dateUpEnd).format("YYYY-MM-DD") : null,
            pageId: pId || 1,
            pageSize: pSize || 10
        }, sortField && sortValue && {
            sortField: sortField,
            sortValue: sortValue
        });
        if (resetList) {
            setRowData([]);
        }
        dispatch(getAllImportInvoiceTt(dataQuery, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    var reLoadData = function() {
        var _ref = _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            setSchImpStart(moment().format("YYYY-MM-DD 00:00:00"))
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            setSchImpEnd(moment().format("YYYY-MM-DD 00:00:00"))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            setPageId(1)
                        ];
                    case 3:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function reLoadData() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleChangePage = function(newPage) {
        setPageId(newPage);
    };
    var handleChangeRowsPerPage = function(newPageSize) {
        setPageSize(newPageSize);
    };
    var handleSort = function(column, sortDirection) {
        var field = column === null || column === void 0 ? void 0 : column.sortField;
        var value = sortDirection; // 'asc' หรือ 'desc'
        console.log("Sort:", {
            sortField: field,
            sortValue: value
        });
        setSortModel({
            sortField: field,
            sortValue: value
        });
    };
    useEffect(function() {
        var init = function init() {
            return _init.apply(this, arguments);
        };
        function _init() {
            _init = _async_to_generator(function() {
                return _ts_generator(this, function(_state) {
                    fetchImportInvoices({
                        dateImportStart: schImpStart,
                        dateImportEnd: schImpEnd,
                        pId: pageId,
                        pSize: pageSize
                    });
                    return [
                        2
                    ];
                });
            });
            return _init.apply(this, arguments);
        }
        init();
    }, []);
    useEffect(function() {
        fetchImportInvoices(_object_spread_props(_object_spread({
            customName: schCusName,
            customCode: schCusCode,
            invoiceCode: schInvCode,
            dateImportStart: schImpStart,
            dateImportEnd: schImpEnd,
            dateDocStart: schDocStart,
            dateDocEnd: schDocEnd,
            dateUpStart: schUpStart,
            dateUpEnd: schUpEnd,
            pId: pageId,
            pSize: pageSize
        }, sortModel && {
            sortField: sortModel.sortField,
            sortValue: sortModel.sortValue
        }), {
            resetList: true
        }));
    }, [
        schCusName,
        schCusCode,
        schInvCode,
        schImpStart,
        schImpEnd,
        schDocStart,
        schDocEnd,
        schUpStart,
        schUpEnd,
        pageId,
        pageSize,
        sortModel
    ]);
    useEffect(function() {
        setIsLoading(getAllImportInvoiceTtReducer.isFetching);
        if (getAllImportInvoiceTtReducer.data && !getAllImportInvoiceTtReducer.isError) {
            var _datas_data, _datas_data1;
            var datas = getAllImportInvoiceTtReducer.data.data;
            if (!datas) {
                return navigate("/404", {
                    replace: true
                });
            }
            if (datas && ((_datas_data = datas.data) === null || _datas_data === void 0 ? void 0 : _datas_data.length) && ((_datas_data1 = datas.data) === null || _datas_data1 === void 0 ? void 0 : _datas_data1.length) > 0) {
                var _datas_data2;
                setRowData((_datas_data2 = datas.data) === null || _datas_data2 === void 0 ? void 0 : _datas_data2.map(function(item) {
                    return _object_spread_props(_object_spread({}, item), {
                        import_inv_total_bath: item.import_inv_total_bath.d.length && item.import_inv_total_bath.d.length > 0 ? filterTextAndNum(item.import_inv_total_bath.d[0], 2) : 0,
                        import_inv_total_doc: item.import_inv_total_doc.d.length && item.import_inv_total_doc.d.length > 0 ? filterTextAndNum(item.import_inv_total_doc.d[0], 2) : 0
                    });
                }));
                var pagination = datas.pagination;
                setTotalPage((pagination === null || pagination === void 0 ? void 0 : pagination.totalPage) || 0);
                setTotalAmount((pagination === null || pagination === void 0 ? void 0 : pagination.total) || 0);
            }
        }
    }, [
        getAllImportInvoiceTtReducer
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0 mb-1",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "จัดการ"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "นำเข้าไฟล์ invoice TT"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 mb-2",
                        children: "นำเข้าไฟล์ invoice TT"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                children: /*#__PURE__*/ _jsxs(Card, {
                    children: [
                        /*#__PURE__*/ _jsx(CardBody, {
                            children: /*#__PURE__*/ _jsxs(Row, {
                                children: [
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 9,
                                        lg: true,
                                        children: /*#__PURE__*/ _jsxs(Row, {
                                            children: [
                                                /*#__PURE__*/ _jsx(Col, {
                                                    xs: 12,
                                                    md: 4,
                                                    lg: 3,
                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                        className: "mb-3 form-st-3 mt-0",
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                className: "mb-1",
                                                                children: "วันที่นำเข้าเริ่มต้น"
                                                            }),
                                                            /*#__PURE__*/ _jsx(DatePicker, {
                                                                inputFormat: "DD/MM/YYYY",
                                                                selected: schImpStart ? moment(schImpStart).toDate() : "",
                                                                onChange: function(date) {
                                                                    if (moment(date).isValid()) {
                                                                        setSchImpStart(moment(date).format("YYYY-MM-DD 00:00:00"));
                                                                    } else {
                                                                        setSchImpStart("");
                                                                    }
                                                                },
                                                                placeholder: "DD/MM/YYYY",
                                                                className: "w-100 datepicker2",
                                                                value: schImpStart ? moment(schImpStart).format("DD/MM/YYYY") : ""
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx(Col, {
                                                    xs: 12,
                                                    md: 4,
                                                    lg: 3,
                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                        className: "mb-3 form-st-3 mt-0",
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                className: "mb-1",
                                                                children: "วันที่นำเข้าสิ้นสุด"
                                                            }),
                                                            /*#__PURE__*/ _jsx(DatePicker, {
                                                                inputFormat: "DD/MM/YYYY",
                                                                selected: schImpEnd ? moment(schImpEnd).toDate() : "",
                                                                onChange: function(date) {
                                                                    if (moment(date).isValid()) {
                                                                        setSchImpEnd(moment(date).format("YYYY-MM-DD 00:00:00"));
                                                                    } else {
                                                                        setSchImpEnd("");
                                                                    }
                                                                },
                                                                placeholder: "DD/MM/YYYY",
                                                                className: "w-100 datepicker2",
                                                                value: schImpEnd ? moment(schImpEnd).format("DD/MM/YYYY") : ""
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx(Col, {
                                                    xs: 12,
                                                    md: 4,
                                                    lg: 3,
                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                        className: "mb-3 form-st-3 mt-0",
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                className: "mb-1",
                                                                children: "วันที่เอกสารเริ่มต้น"
                                                            }),
                                                            /*#__PURE__*/ _jsx(DatePicker, {
                                                                inputFormat: "DD/MM/YYYY",
                                                                selected: schDocStart ? moment(schDocStart).toDate() : "",
                                                                onChange: function(date) {
                                                                    if (moment(date).isValid()) {
                                                                        setSchDocStart(moment(date).format("YYYY-MM-DD 00:00:00"));
                                                                    } else {
                                                                        setSchDocStart("");
                                                                    }
                                                                },
                                                                placeholder: "DD/MM/YYYY",
                                                                className: "w-100 datepicker2",
                                                                value: schDocStart ? moment(schDocStart).format("DD/MM/YYYY") : ""
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx(Col, {
                                                    xs: 12,
                                                    md: 4,
                                                    lg: 3,
                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                        className: "mb-3 form-st-3 mt-0",
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                className: "mb-1",
                                                                children: "วันที่เอกสารสิ้นสุด"
                                                            }),
                                                            /*#__PURE__*/ _jsx(DatePicker, {
                                                                inputFormat: "DD/MM/YYYY",
                                                                selected: schDocEnd ? moment(schDocEnd).toDate() : "",
                                                                onChange: function(date) {
                                                                    if (moment(date).isValid()) {
                                                                        setSchDocEnd(moment(date).format("YYYY-MM-DD 00:00:00"));
                                                                    } else {
                                                                        setSchDocEnd("");
                                                                    }
                                                                },
                                                                placeholder: "DD/MM/YYYY",
                                                                className: "w-100 datepicker2",
                                                                value: schDocEnd ? moment(schDocEnd).format("DD/MM/YYYY") : ""
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx(Col, {
                                                    xs: 12,
                                                    md: 4,
                                                    lg: 3,
                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                        className: "mb-3 form-st-3 mt-0",
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                className: "mb-1",
                                                                children: "วันที่อัพเดทเริ่มต้น"
                                                            }),
                                                            /*#__PURE__*/ _jsx(DatePicker, {
                                                                inputFormat: "DD/MM/YYYY",
                                                                selected: schUpStart ? moment(schUpStart).toDate() : "",
                                                                onChange: function(date) {
                                                                    if (moment(date).isValid()) {
                                                                        setSchUpStart(moment(date).format("YYYY-MM-DD 00:00:00"));
                                                                    } else {
                                                                        setSchUpStart("");
                                                                    }
                                                                },
                                                                placeholder: "DD/MM/YYYY",
                                                                className: "w-100 datepicker2",
                                                                value: schUpStart ? moment(schUpStart).format("DD/MM/YYYY") : ""
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx(Col, {
                                                    xs: 12,
                                                    md: 4,
                                                    lg: 3,
                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                        className: "mb-3 form-st-3 mt-0",
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                className: "mb-1",
                                                                children: "วันที่อัพเดทสิ้นสุด"
                                                            }),
                                                            /*#__PURE__*/ _jsx(DatePicker, {
                                                                inputFormat: "DD/MM/YYYY",
                                                                selected: schUpEnd ? moment(schUpEnd).toDate() : "",
                                                                onChange: function(date) {
                                                                    if (moment(date).isValid()) {
                                                                        setSchUpEnd(moment(date).format("YYYY-MM-DD 00:00:00"));
                                                                    } else {
                                                                        setSchUpEnd("");
                                                                    }
                                                                },
                                                                placeholder: "DD/MM/YYYY",
                                                                className: "w-100 datepicker2",
                                                                value: schUpEnd ? moment(schUpEnd).format("DD/MM/YYYY") : ""
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx(Col, {
                                                    xs: 12,
                                                    md: 4,
                                                    lg: 3,
                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                        className: "mb-3 form-st-3 mt-0",
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                className: "mb-1",
                                                                children: "เลขที่เอกสาร"
                                                            }),
                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                type: "text",
                                                                placeholder: "ค้นหา เลขที่เอกสาร",
                                                                onChange: function(e) {
                                                                    return setSchInvCode(e.target.value);
                                                                },
                                                                value: schInvCode
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx(Col, {
                                                    xs: 12,
                                                    md: 4,
                                                    lg: 3,
                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                        className: "mb-3 form-st-3 mt-0",
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                className: "mb-1",
                                                                children: "รหัสลูกค้า"
                                                            }),
                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                type: "text",
                                                                placeholder: "ค้นหา รหัสลูกค้า",
                                                                onChange: function(e) {
                                                                    return setSchCusCode(e.target.value);
                                                                },
                                                                value: schCusCode
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ _jsx(Col, {
                                                    xs: 12,
                                                    md: 4,
                                                    lg: 3,
                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                        className: "mb-3 form-st-3 mt-0",
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                className: "mb-1",
                                                                children: "ชื่อลูกค้า"
                                                            }),
                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                type: "text",
                                                                placeholder: "ค้นหา ชื่อลูกค้า",
                                                                onChange: function(e) {
                                                                    return setSchCusName(e.target.value);
                                                                },
                                                                value: schCusName
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Col, {
                                        xs: 12,
                                        md: 6,
                                        lg: "auto",
                                        children: /*#__PURE__*/ _jsx(Stack, {
                                            direction: "horizontal",
                                            children: /*#__PURE__*/ _jsx(Button, {
                                                className: "btn btn-dg ml-2 w-[250px] fs-14",
                                                onClick: function() {
                                                    return setModalShow(true);
                                                },
                                                children: "นำเข้าข้อมูล"
                                            })
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx(DatatableLayoutPagination, {
                            item: rowData,
                            columns: columns,
                            isSelectRows: false,
                            currentPage: pageId,
                            currentPageSize: pageSize,
                            onChangePage: handleChangePage,
                            onChangePageSize: handleChangeRowsPerPage,
                            totalPage: totalPage,
                            totalAmount: totalAmount,
                            sortModel: sortModel,
                            onChangeSort: setSortModel,
                            handleSort: handleSort,
                            loading: loading
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(ImportFileModal, {
                show: modalShow,
                onHide: function() {
                    return setModalShow(false);
                },
                setInvoiceData: setInvoiceData,
                invoiceData: invoiceData,
                previewId: previewId,
                setPreviewId: setPreviewId,
                sumTotalInv: sumTotalInv,
                setSumTotalInv: setSumTotalInv,
                modalTitle: "นำเข้าไฟล์ invoice TT",
                modalType: "TT",
                previewShow: function() {
                    setModalShow(false);
                    setDetailShow(true);
                }
            }),
            /*#__PURE__*/ _jsx(SaveItemModal, {
                show: detailShow,
                onHide: function() {
                    return setDetailShow(false);
                },
                setInvoiceData: setInvoiceData,
                invoiceData: invoiceData,
                previewId: previewId,
                setPreviewId: setPreviewId,
                sumTotalInv: sumTotalInv,
                setSumTotalInv: setSumTotalInv,
                modalTitle: "ข้อมูล invoice TT",
                modalType: "TT",
                setTextsuccess: setTextsuccess,
                successShow: function() {
                    reLoadData();
                    setDetailShow(false);
                    setModalsuccess(true);
                }
            }),
            /*#__PURE__*/ _jsx(SuccessModal, {
                show: modalsuccess,
                onHide: function() {
                    return setModalsuccess(false);
                },
                textsuccess: textsuccess,
                navigate: navigate
            })
        ]
    });
}
function ImportFileModal(_param) {
    var invoiceData = _param.invoiceData, setInvoiceData = _param.setInvoiceData, props = _object_without_properties(_param, [
        "invoiceData",
        "setInvoiceData"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var modalType = props.modalType ? props.modalType.trim() : "";
    var uploadImportFileInvMtReducer = useAppSelector(function(state) {
        return state.uploadImportFileInvMtReducer;
    });
    var uploadImportFileInvTtReducer = useAppSelector(function(state) {
        return state.uploadImportFileInvTtReducer;
    });
    var handleChange = function() {};
    var handleClose = function() {
        return props.onHide();
    };
    var handleClick = function() {
        props.previewShow();
    };
    var _useState = _sliced_to_array(useState([]), 2), uploads = _useState[0], setUploads = _useState[1];
    var onDrop = useCallback(function(acceptedFiles) {
        var newFiles = acceptedFiles.map(function(file) {
            return {
                file: file,
                status: "pending",
                progress: 0,
                error: null,
                id: null,
                url: null
            };
        });
        setUploads(function(prev) {
            return _to_consumable_array(prev).concat(_to_consumable_array(newFiles));
        });
        newFiles.forEach(function(fileObj, index) {
            uploadFile(fileObj, uploads.length + index);
        });
    }, [
        uploads
    ]);
    var uploadFile = function() {
        var _ref = _async_to_generator(function(fileObj, index) {
            var formData;
            return _ts_generator(this, function(_state) {
                formData = new FormData();
                formData.append("fileupload", fileObj.file);
                setUploads(function(prev) {
                    return prev.map(function(item, i) {
                        return i === index ? _object_spread_props(_object_spread({}, item), {
                            status: "uploading",
                            progress: 0
                        }) : item;
                    });
                });
                try {
                    if (modalType == "MT") {
                        dispatch(uploadImportFileInvMt(formData, {
                            modalObj: modalObj,
                            setModalObj: setModalObj
                        }));
                    } else if (modalType == "TT") {
                        dispatch(uploadImportFileInvTt(formData, {
                            modalObj: modalObj,
                            setModalObj: setModalObj
                        }));
                    } else {
                        setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                            visible: true,
                            subTitle: "รหัส 201",
                            navigateDirection: undefined,
                            title: "ไม่พบประเภทตามกำหนดไว้"
                        }));
                        props.onHide();
                    }
                    setUploads(function(prev) {
                        return prev.map(function(item, i) {
                            return i === index ? _object_spread_props(_object_spread({}, item), {
                                status: "success"
                            }) : item;
                        });
                    });
                //props.previewShow();
                } catch (error) {
                    setUploads(function(prev) {
                        return prev.map(function(item, i) {
                            var _error_response_data, _error_response;
                            return i === index ? _object_spread_props(_object_spread({}, item), {
                                status: "error",
                                error: (error === null || error === void 0 ? void 0 : (_error_response = error.response) === null || _error_response === void 0 ? void 0 : (_error_response_data = _error_response.data) === null || _error_response_data === void 0 ? void 0 : _error_response_data.message) || (error === null || error === void 0 ? void 0 : error.message) || "อัปโหลดล้มเหลว"
                            }) : item;
                        });
                    });
                }
                return [
                    2
                ];
            });
        });
        return function uploadFile(fileObj, index) {
            return _ref.apply(this, arguments);
        };
    }();
    var _useDropzone = useDropzone({
        onDrop: onDrop,
        accept: {
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
                ".xlsx"
            ],
            "application/vnd.ms-excel": [
                ".xls"
            ],
            "text/csv": [
                ".csv"
            ]
        },
        multiple: true
    }), getRootProps = _useDropzone.getRootProps, getInputProps = _useDropzone.getInputProps, isDragActive = _useDropzone.isDragActive;
    useEffect(function() {
        setIsLoading(uploadImportFileInvMtReducer.isFetching);
        if (uploadImportFileInvMtReducer.data && !uploadImportFileInvMtReducer.isError) {
            var updatedData = uploadImportFileInvMtReducer.data.data;
            dispatch(clearUploadImportFileInvMt());
            var dataPreviewId = updatedData.data.previewId && updatedData.data.previewId > 0 ? updatedData.data.previewId : null;
            var dataPreviewArr = updatedData.data.previewRows && updatedData.data.previewRows.length && updatedData.data.previewRows.length > 0 ? updatedData.data.previewRows : [];
            var dataTotalRow = updatedData.data.totalRows && updatedData.data.totalRows > 0 ? updatedData.data.totalRows : 0;
            var dataTotalArr = updatedData.data.previewTotals && updatedData.data.previewTotals.length && updatedData.data.previewTotals.length > 0 ? updatedData.data.previewTotals : [];
            var dataTotalNet = 0;
            if (dataTotalArr && dataTotalArr.length && dataTotalArr.length > 0) {
                dataTotalArr.map(function(item, i) {
                    if (item.net_amount && item.net_amount > 0.001) {
                        dataTotalNet = parseFloat(dataTotalNet) + parseFloat(item.net_amount);
                    }
                });
            }
            // console.log('dataPreviewId', dataPreviewId);
            // console.log('dataPreviewArr', dataPreviewArr);
            // console.log('dataTotalRow', dataTotalRow);
            // console.log('dataTotalNet', dataTotalNet);
            if (dataPreviewId && dataPreviewId > 0 && dataPreviewArr && (dataPreviewArr === null || dataPreviewArr === void 0 ? void 0 : dataPreviewArr.length) && (dataPreviewArr === null || dataPreviewArr === void 0 ? void 0 : dataPreviewArr.length) > 0) {
                props.setPreviewId(dataPreviewId);
                setInvoiceData(dataPreviewArr);
                props.setSumTotalInv(_object_spread_props(_object_spread({}, props.sumTotalInv), {
                    amountInv: dataTotalRow,
                    amountTotal: dataTotalNet
                }));
                props.previewShow();
            } else {
                setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                    visible: true,
                    subTitle: "รหัส 201",
                    navigateDirection: undefined,
                    title: "ไม่พบข้อมูล preview (previewId = ".concat(dataPreviewId, ", invoiceData = ").concat(dataPreviewArr === null || dataPreviewArr === void 0 ? void 0 : dataPreviewArr.length, ")")
                }));
                props.onHide();
            }
        }
    }, [
        uploadImportFileInvMtReducer
    ]);
    useEffect(function() {
        setIsLoading(uploadImportFileInvTtReducer.isFetching);
        if (uploadImportFileInvTtReducer.data && !uploadImportFileInvTtReducer.isError) {
            var updatedData = uploadImportFileInvTtReducer.data.data;
            dispatch(clearUploadImportFileInvTt());
            var dataPreviewId = updatedData.data.previewId && updatedData.data.previewId > 0 ? updatedData.data.previewId : null;
            var dataPreviewArr = updatedData.data.previewRows && updatedData.data.previewRows.length && updatedData.data.previewRows.length > 0 ? updatedData.data.previewRows : [];
            var dataTotalRow = updatedData.data.totalRows && updatedData.data.totalRows > 0 ? updatedData.data.totalRows : 0;
            var dataTotalArr = updatedData.data.previewTotals && updatedData.data.previewTotals.length && updatedData.data.previewTotals.length > 0 ? updatedData.data.previewTotals : [];
            var dataTotalNet = 0;
            if (dataTotalArr && dataTotalArr.length && dataTotalArr.length > 0) {
                dataTotalArr.map(function(item, i) {
                    if (item.net_amount && item.net_amount > 0.001) {
                        dataTotalNet = parseFloat(dataTotalNet) + parseFloat(item.net_amount);
                    }
                });
            }
            if (dataPreviewId && dataPreviewId > 0 && dataPreviewArr && (dataPreviewArr === null || dataPreviewArr === void 0 ? void 0 : dataPreviewArr.length) && (dataPreviewArr === null || dataPreviewArr === void 0 ? void 0 : dataPreviewArr.length) > 0) {
                props.setPreviewId(dataPreviewId);
                setInvoiceData(dataPreviewArr);
                props.setSumTotalInv(_object_spread_props(_object_spread({}, props.sumTotalInv), {
                    amountInv: dataTotalRow,
                    amountTotal: dataTotalNet
                }));
                props.previewShow();
            } else {
                setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                    visible: true,
                    subTitle: "รหัส 201",
                    navigateDirection: undefined,
                    title: "ไม่พบข้อมูล preview (previewId = ".concat(dataPreviewId, ", invoiceData = ").concat(dataPreviewArr === null || dataPreviewArr === void 0 ? void 0 : dataPreviewArr.length, ")")
                }));
                props.onHide();
            }
        }
    }, [
        uploadImportFileInvTtReducer
    ]);
    return /*#__PURE__*/ _jsxs(Modal, _object_spread_props(_object_spread({}, rest), {
        size: "md",
        centered: true,
        children: [
            /*#__PURE__*/ _jsx(Modal.Header, {
                closeButton: true,
                className: "modal-header-danger",
                children: /*#__PURE__*/ _jsx(Modal.Title, {
                    children: props.modalTitle
                })
            }),
            /*#__PURE__*/ _jsx(Modal.Body, {
                children: /*#__PURE__*/ _jsx("div", {
                    className: "align-items-center",
                    children: /*#__PURE__*/ _jsxs("div", _object_spread_props(_object_spread({}, getRootProps()), {
                        className: "border border-2 rounded p-5 text-center bg-light",
                        style: {
                            cursor: "pointer"
                        },
                        children: [
                            /*#__PURE__*/ _jsx("input", _object_spread({}, getInputProps())),
                            isDragActive ? /*#__PURE__*/ _jsx("p", {
                                children: "ปล่อยไฟล์ที่นี่..."
                            }) : /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx("p", {
                                        children: "ลากไฟล์มาวางที่นี่ หรือคลิกเพื่อเลือกไฟล์"
                                    }),
                                    /*#__PURE__*/ _jsx("p", {
                                        style: {
                                            color: "#A9ACB4"
                                        },
                                        children: ' "ระบบรองรับไฟล์ .xlsx, .xls, .csv เท่านั้น'
                                    })
                                ]
                            })
                        ]
                    }))
                })
            }),
            /*#__PURE__*/ _jsx(Modal.Footer, {
                children: /*#__PURE__*/ _jsx(Button, {
                    variant: "outline-secondary",
                    onClick: handleClose,
                    children: "ยกเลิก"
                })
            })
        ]
    }));
}
function SaveItemModal(_param) {
    var invoiceData = _param.invoiceData, setInvoiceData = _param.setInvoiceData, props = _object_without_properties(_param, [
        "invoiceData",
        "setInvoiceData"
    ]);
    var rest = _extends({}, _object_destructuring_empty(props));
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var modalType = props.modalType ? props.modalType.trim() : "";
    var previewId = props.previewId ? props.previewId : null;
    var sumTotalInv = props.sumTotalInv ? props.sumTotalInv : {
        amountInv: 0,
        amountTotal: 0
    };
    var _useState = _sliced_to_array(useState(""), 2), filterTextModal = _useState[0], setFilterTextModal = _useState[1];
    var _useState1 = _sliced_to_array(useState([]), 2), filteredItemsModal = _useState1[0], setFilteredItemsModal = _useState1[1];
    var _useState2 = _sliced_to_array(useState(""), 2), dateImport = _useState2[0], setDateImport = _useState2[1];
    var confirmImportInvMtReducer = useAppSelector(function(state) {
        return state.confirmImportInvMtReducer;
    });
    var confirmImportInvTtReducer = useAppSelector(function(state) {
        return state.confirmImportInvTtReducer;
    });
    var handleChange = function() {};
    var handleClose = function() {
        return props.onHide();
    };
    var handleClick = function() {
        var dataQuery = {
            previewId: previewId ? parseInt(previewId) : null
        };
        if (modalType && modalType == "MT") {
            dispatch(confirmImportInvMt(dataQuery, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        } else if (modalType && modalType == "TT") {
            dispatch(confirmImportInvTt(dataQuery, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        } else {
            setModalObj(_object_spread_props(_object_spread({}, modalObj), {
                visible: true,
                subTitle: "รหัส 201",
                navigateDirection: undefined,
                title: "ไม่พบประเภทตามกำหนดไว้"
            }));
            props.onHide();
        }
    };
    var columns = [
        {
            name: "รหัสลูกค้า",
            selector: function(row) {
                return row.customer_code || "-";
            },
            center: "true",
            minWidth: "200px"
        },
        {
            name: "ชื่อลูกค้า",
            selector: function(row) {
                return row.customer_name || "-";
            },
            minWidth: "200px"
        },
        {
            name: "วันที่เอกสาร",
            selector: function(row) {
                return row.document_date;
            },
            right: "true",
            minWidth: "150px",
            cell: function(row) {
                return /*#__PURE__*/ _jsx(_Fragment, {
                    children: row.document_date && row.document_date != "" && row.document_date != null ? moment(row.document_date).format("DD/MM/YYYY") : "-"
                });
            }
        },
        {
            name: "เลขที่เอกสาร",
            selector: function(row) {
                return row.document_no || "-";
            },
            center: "true",
            minWidth: "200px"
        },
        {
            name: "ยอดรวมสุธิ (บาท)",
            selector: function(row) {
                return row.net_amount;
            },
            right: "true",
            minWidth: "200px",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx("div", {
                    className: "w-100 text-right",
                    children: formatNumber(row.net_amount) || "0.00"
                });
            }
        },
        {
            name: "สกุลเงินในเอกสาร",
            selector: function(row) {
                return row.currency_code || "-";
            },
            center: "true",
            minWidth: "150px"
        },
        {
            name: "ยอดรวมสุทธิ(ตามเอกสาร)",
            selector: function(row) {
                return row.net_amount_doc;
            },
            right: "true",
            minWidth: "200px",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx("div", {
                    className: "w-100 text-right",
                    children: formatNumber(row.net_amount_doc) || "0.00"
                });
            }
        },
        {
            name: "สถานะ",
            selector: function(row) {
                return row.status;
            },
            center: "true",
            width: "180px",
            sortable: true,
            sortField: "status",
            cell: function(row, index, column, id) {
                return row.status == 1 ? /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "rgba(114, 225, 40, 0.87)",
                        backgroundColor: "rgba(238, 251, 229, 1)",
                        borderRadius: "20px",
                        width: "130px"
                    },
                    children: row.status_text || "ชำระแล้ว"
                }) : row.status == 2 ? /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "rgba(253, 180, 40, 1)",
                        backgroundColor: "rgba(255, 246, 229, 1)",
                        borderRadius: "20px",
                        width: "130px"
                    },
                    children: row.status_text || "รอชำระ"
                }) : /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "rgba(116, 116, 116, 1)",
                        backgroundColor: "rgba(244, 244, 244, 1)",
                        borderRadius: "20px",
                        width: "130px"
                    },
                    children: row.status_text || "ไม่ระบุ"
                });
            }
        }
    ];
    useEffect(function() {
        if (invoiceData && invoiceData.length > 0) {
            if (filterTextModal && filterTextModal != "" && filterTextModal != null) {
                var filtered = invoiceData.filter(function(item) {
                    return item.customer_name != null && item.customer_name.includes(filterTextModal) || item.customer_code != null && item.customer_code.toUpperCase().includes(filterTextModal.toUpperCase()) || item.document_no != null && item.document_no.toUpperCase().includes(filterTextModal.toUpperCase());
                });
                setFilteredItemsModal(filtered);
            } else {
                setFilteredItemsModal(invoiceData);
            }
        } else {
            setFilteredItemsModal([]);
        }
    }, [
        filterTextModal,
        invoiceData
    ]);
    useEffect(function() {
        setIsLoading(confirmImportInvMtReducer.isFetching);
        if (confirmImportInvMtReducer.data && !confirmImportInvMtReducer.isError) {
            var saveData = confirmImportInvMtReducer.data.data;
            dispatch(clearConfirmImportInvMt());
            // console.log('saveData',saveData);
            if (saveData.data.importId && saveData.data.importId > 0) {
                props.setTextsuccess("นำเข้าไฟล์ invoice MT เรียบร้อย");
                props.successShow();
            }
        }
    }, [
        confirmImportInvMtReducer
    ]);
    useEffect(function() {
        setIsLoading(confirmImportInvTtReducer.isFetching);
        if (confirmImportInvTtReducer.data && !confirmImportInvTtReducer.isError) {
            var saveData = confirmImportInvTtReducer.data.data;
            dispatch(clearConfirmImportInvTt());
            if (saveData.data.importId && saveData.data.importId > 0) {
                props.setTextsuccess("นำเข้าไฟล์ invoice TT เรียบร้อย");
                props.successShow();
            }
        }
    }, [
        confirmImportInvTtReducer
    ]);
    return /*#__PURE__*/ _jsxs(Modal, _object_spread_props(_object_spread({}, rest), {
        size: "lg",
        centered: true,
        children: [
            /*#__PURE__*/ _jsx(Modal.Header, {
                closeButton: true,
                className: "modal-header-danger",
                children: /*#__PURE__*/ _jsx(Modal.Title, {
                    children: props.modalTitle
                })
            }),
            /*#__PURE__*/ _jsxs(Modal.Body, {
                children: [
                    /*#__PURE__*/ _jsxs(Row, {
                        className: "align-items-center",
                        children: [
                            /*#__PURE__*/ _jsx(Col, {
                                xs: 12,
                                md: "auto",
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "card card-st-3 mb-3 !bg-[#d5eafa] !text-[#000]",
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: "card-body",
                                        children: [
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "fs-20 mb-2",
                                                children: [
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "me-2",
                                                        children: /*#__PURE__*/ _jsx(ReceiptIcon, {})
                                                    }),
                                                    "จำนวนรายการ"
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "fs-18 mb-2 text-right",
                                                children: (sumTotalInv === null || sumTotalInv === void 0 ? void 0 : sumTotalInv.amountInv) && (sumTotalInv === null || sumTotalInv === void 0 ? void 0 : sumTotalInv.amountInv) > 0 ? formatNumber(sumTotalInv === null || sumTotalInv === void 0 ? void 0 : sumTotalInv.amountInv, 0) : 0
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsx(Col, {
                                xs: 12,
                                md: "auto",
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "card card-st-3 mb-3 !bg-[#d4f3cd] !text-[#000]",
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: "card-body",
                                        children: [
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "fs-20 mb-2",
                                                children: [
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "me-2",
                                                        children: /*#__PURE__*/ _jsx(LocalAtmIcon, {})
                                                    }),
                                                    "มูลค่า"
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "fs-18 mb-2 text-right",
                                                children: (sumTotalInv === null || sumTotalInv === void 0 ? void 0 : sumTotalInv.amountTotal) && (sumTotalInv === null || sumTotalInv === void 0 ? void 0 : sumTotalInv.amountTotal) > 0 ? formatNumber(sumTotalInv === null || sumTotalInv === void 0 ? void 0 : sumTotalInv.amountTotal, 2) + " บาท" : "0.00 บาท"
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Row, {
                        className: "align-items-center mb-3",
                        children: [
                            /*#__PURE__*/ _jsx(Col, {
                                xs: 12,
                                md: true
                            }),
                            /*#__PURE__*/ _jsx(Col, {
                                xs: 6,
                                md: "auto",
                                children: /*#__PURE__*/ _jsx(Stack, {
                                    direction: "horizontal",
                                    children: /*#__PURE__*/ _jsx(Form.Control, {
                                        type: "text",
                                        placeholder: "ค้นหา ชื่อลูกค้า, รหัสลูกค้า, เลขที่เอกสาร",
                                        onChange: function(e) {
                                            return setFilterTextModal(e.target.value);
                                        },
                                        className: "form-control"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(DataTableLayout, {
                        item: filteredItemsModal,
                        columns: columns,
                        isSelectRows: false,
                        PerPage: 10
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(Modal.Footer, {
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "outline-secondary",
                        onClick: handleClose,
                        children: "ยกเลิก"
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "danger",
                        onClick: handleClick,
                        children: "ยืนยัน"
                    })
                ]
            })
        ]
    }));
}
function SuccessModal(_param) {
    var navigate = _param.navigate, show = _param.show, direction = _param.direction, props = _object_without_properties(_param, [
        "navigate",
        "show",
        "direction"
    ]);
    var handleCloseAndNavigate = function() {
        props.onHide();
        if (direction) {
            navigate(direction);
        }
    };
    return /*#__PURE__*/ _jsx(Modal, _object_spread_props(_object_spread({}, props), {
        size: "sm",
        centered: true,
        show: show,
        onHide: handleCloseAndNavigate,
        children: /*#__PURE__*/ _jsx(Modal.Body, {
            children: /*#__PURE__*/ _jsxs("div", {
                className: "px-3 py-4",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mb-4",
                        children: /*#__PURE__*/ _jsxs("svg", {
                            width: "84",
                            height: "83",
                            viewBox: "0 0 84 83",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            className: "mx-auto",
                            children: [
                                /*#__PURE__*/ _jsx("circle", {
                                    cx: "42",
                                    cy: "41.5",
                                    r: "41.5",
                                    fill: "#2DC76D"
                                }),
                                /*#__PURE__*/ _jsx("path", {
                                    d: "M56.0123 30.9902L36.7444 50.2581L27.9863 41.5",
                                    stroke: "white",
                                    strokeWidth: "5",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center fs-18 tc-7",
                        children: props.textsuccess
                    })
                ]
            })
        })
    }));
}
